<div class="flex flex-col gap-6">
  <go-back class="w-full flex-start flex sm:hidden mb-2"></go-back>
  <!-- seeds banner -->
  <div class="flex flex-col">
    <div class="relative overflow-hidden rounded-t-lg">
      <img
        src="../../../../../../assets/img/seeds.svg"
        alt=""
        class="max-h-[13.3rem] md:max-h-[12.25rem] hidden md:block w-full h-auto object-cover"
      />
      <img
        src="../../../../../../assets/img/SeedsMobile.svg"
        alt=""
        class="max-h-[13.3rem] md:max-h-[12.25rem] block md:hidden w-full h-auto object-cover"
      />
      <div class="absolute px-4 py-2 flex gap-2 items-center top-2 left-2 ganas-earned rounded-lg z-1">
        <div class="text-[1.9375rem]/[160%] md:text-[] text-[#003555] font-bold">
          {{ currentUser()?.totalReferrals }}
        </div>
        <div class="text-[1.375rem]/[160%] md:text-[] text-[#0072B9]">{{ 'my-referrals.seeds' | translate }}</div>
        <i
          nz-tooltip
          appHideTooltipOnScroll
          [nzTooltipTitle]="'my-referrals.seedsTooltip' | translate"
          [nzTooltipPlacement]="'bottomLeft'"
          [nzTooltipArrowPointAtCenter]="true"
          [nzTooltipOverlayClassName]="'seeds-tooltip-overlay'"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M12.0016 2C17.5253 2 22.0031 6.47784 22.0031 12.0016C22.0031 17.5253 17.5253 22.003 12.0016 22.003C6.47784 22.003 2 17.5253 2 12.0016C2 6.47784 6.47784 2 12.0016 2ZM12.0016 3.5C7.30627 3.5 3.5 7.30627 3.5 12.0016C3.5 16.6969 7.30627 20.503 12.0016 20.503C16.6969 20.503 20.5031 16.6969 20.5031 12.0016C20.5031 7.30627 16.6969 3.5 12.0016 3.5ZM11.9979 10.5006C12.3776 10.5003 12.6916 10.7823 12.7415 11.1484L12.7484 11.2501L12.752 16.7517C12.7523 17.1659 12.4167 17.502 12.0025 17.5022C11.6228 17.5025 11.3088 17.2205 11.2589 16.8545L11.252 16.7527L11.2484 11.251C11.2482 10.8369 11.5837 10.5009 11.9979 10.5006ZM12.002 7.00281C12.5536 7.00281 13.0007 7.44993 13.0007 8.00148C13.0007 8.55302 12.5536 9.00014 12.002 9.00014C11.4505 9.00014 11.0034 8.55302 11.0034 8.00148C11.0034 7.44993 11.4505 7.00281 12.002 7.00281Z"
              fill="#007DCB"
            />
          </svg>
        </i>
      </div>
    </div>
    <div class="flex-1 px-6 py-6 md:py-4 flex flex-col md:flex-row card gap-4">
      <div class="flex flex-col items-center md:items-start flex-1">
        <span class="text-[1.1875rem]/[160%] md:text-[1.375rem]/[160%] font-bold">{{
          'my-referrals.yourForestIsGrowing' | translate
        }}</span>
        <span class="text-[0.8125rem]/[160%] md:text-[1.125rem]/[160%] font-light">{{
          'my-referrals.yourSeedsWillBecomeGanarbolsSoon' | translate
        }}</span>
      </div>
      <div class="flex flex-col md:flex-row gap-4 items-center">
        <korviu-button class="h-[3.3rem] w-full" color="ghost" (onclick)="exploreMyForest()">
          <span class="text-[1rem]/[160%] md:text-[1.125rem]/[160%]">{{
            'my-referrals.exploreForest' | translate
          }}</span>
        </korviu-button>
        <korviu-button class="h-[3.3rem] w-full" color="tertiary" (onclick)="addReferral()">
          <span class="text-[1rem]/[160%] md:text-[1.125rem]/[160%]">{{ 'my-referrals.sowingSeed' | translate }}</span>
        </korviu-button>
      </div>
    </div>
  </div>
  <!-- removed referral alerts -->
  @for (referral of removedReferrals(); track referral.id) {
    <app-alert type="info" (closed)="dismissAlert(referral.id)">
      <div class="flex flex-col">
        <span class="font-medium">{{ 'my-referrals.removedFromSeeds' | translate: { name: referral.full_name } }}</span>
        <span class="font-light">{{
          'my-referrals.removedFromSeedsDescription' | translate: { name: referral.full_name }
        }}</span>
      </div>
    </app-alert>
  }
  @if (noReferrals()) {
    <app-referral-active-missions />
  }
  <!-- seed list -->
  <korviu-list [config]="seedListConfig">
    <ng-template emptyTemplate>
      @if (showReferralEmptyState()) {
        <div class="flex flex-col items-center py-4 text-center">
          <img src="assets/img/my-referrals/empty.svg" alt="" class="mb-6 size-[7.75rem]" />
          <p class="mb-8 max-w-[17.25rem] text-[0.9375rem]/[160%] text-[#737980]">
            {{ 'my-referrals.youDontHaveAnySeedsYet' | translate }}
          </p>
          <korviu-button
            color="tertiary"
            size="small"
            [style.--button__border-radius]="'0.375rem'"
            [style.--button__height]="'2.5rem'"
            (onclick)="addReferral()"
          >
            {{ 'my-referrals.inviteReferral' | translate }}
          </korviu-button>
        </div>
      } @else {
        <korviu-no-data />
      }
    </ng-template>
  </korviu-list>
</div>
